const messages = {
    ADDED: 'ADDED',
    ALREADY_EXISTED: 'ALREADY_EXISTED',
    INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
    STATUS_UNKNOWN: 'STATUS_UNKNOWN'
}

export default messages;